import { createFileRoute } from '@tanstack/react-router';
import { SportsPage } from '../pages/sports/sports-page';

export const Route = createFileRoute('/sports/')({
  component: SportsPage,
});
